import { DEFAULT_PAGE_SIZES } from '~/src/components/common-components/pagination/components/page-limiter/page-limiter.constants';

export class AgentsLeadsListState {
    currentPage: number = 1;
    currentPageSize: number = DEFAULT_PAGE_SIZES[0];
    filter = new AgentsLeadsFilterParamsState();
    isActiveFilter: boolean = false;
}

export class AgentsLeadsFilterParamsState {
    searchString: string = '';
}